import React from 'react'
import image from '../assets/images/vegan.jpg';
import Navbar from './navbar';
import {Link} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import {useEffect,useState} from 'react'
import UseFetch from '../hooks/useFetch';
import UseAdd from '../hooks/useAdd';
import { useNavigate } from 'react-router-dom';

interface Product{
category:Number
created_at:Date
description:string
id:string
images:{ image: string }[]
name:string
owner:Number
price:string
image:string
}
function Detail() {
    const [isAuthenticatd,setIsAuthenticated] = useState(true)
    const [token,setToken] = useState<string>('')
    const {id} = useParams()
    const productId = id ? id : 1
    const {data,getData} = UseFetch()
    const tokenData = localStorage.getItem('authToken')
    const navigate = useNavigate()
    useEffect(() => {
        if (data.length === 0) {
          const fetchData = async () => {
            await getData();
          };
    
          fetchData();
        }
        setToken(tokenData || '')

      }, [getData, data]);

      const direction = isAuthenticatd ? '/login' :'/cart';
  

const singleData = data.find((item:Product)=> item.id ==id) || {image:'',images:[{ image: '' }], name: '' ,price:'',description:''}
const price = singleData.price
const {addToCart} = UseAdd({token,productId,price})
  const addToCartHandler =()=>{
    addToCart()
    navigate('/cart')

    }
return (
    <>
    <Navbar/>
    <div className='detail'>
      <div className='left-detail'>
      <img className='detail-image' src={`https://djangodrf.arifsultani291.digital/products/${singleData.images[0].image}`}/>
      <div className='detail-images'>
       <img className='img' src={image} />
       <img className='img' src={image} />
       <img className='img' src={image} />
       <img className='img' src={image} />
      </div>
      </div>
      <div className='right-detail'>
       <h1>{singleData?.name}</h1>
       <p>{singleData.description}</p>
       <h4>${singleData.price}</h4>
       {tokenData && <button className='loginBtn' onClick={addToCartHandler}>Add to Cart</button>}
       {!tokenData && <Link to={direction} className='btnCart'>Add to Cart</Link>}
      </div>
    </div>
    </>
  )
}

export default Detail
